import { LangCodes } from "../types";
export var defaultLangCode = LangCodes.ru_RU;